import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const FOOD_CATEGORIES = [
  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/mexican-cuisine.jpg", label: "Mexican" },
  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/lunchnew.jpg", label: "Lunch" },
  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/cheapeat.jpg", label: "Cheap Eats" },
  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/coffytea.jpg", label: "Coffee & Tea" },
  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/seafoodnew.jpg", label: "Seafood" },
  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/brkfirstImg.jpg", label: "Breakfast" },
  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/chinese-cuisine.jpg", label: "Chinese" },
  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/italian-cuisine.jpg", label: "Italian" },
  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/pizza-cuisine.jpg", label: "Pizza" },
  { src: "https://www.mysittivacations.com/backend/assets/images/city_images/barbecue-beef.jpg", label: "Barbeque" },
];

export default function SecondSlider({ handleClick }) {
  const place = useSelector((state) => state.place);

  if (!FOOD_CATEGORIES.length) return null;

  return (
    <>
      <div
        className="delivery_restaurant_header"
      >
        <h2> {place
          ? `${place.replace(/\b\w/g, (x) => x.toUpperCase())} by Food`
          : "By Food"}</h2>
      </div>


      <div className="mt--60 mb-5">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={20}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={true}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 2 },
            1400: { slidesPerView: 3 },
          }}
          className="restaurent-swiper mt-0"
        >
          {FOOD_CATEGORIES.map(({ src, label }) => (
            <SwiperSlide key={label} className="col-lg-6 col-md-12">
              <div className="resorts-box p-3 bg-white" onClick={() => handleClick?.(label)}>
                <figure>
                  <img
                    src={src} alt={label} loading="lazy"
                    className="img-fluid"
                  />
                </figure>

                <div className="resorts-content-box">
                  <div className="resort-description border-0 m-0">
                    <h3>{label}</h3>
                  </div>
                </div>

              </div>

            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}
